/**
 * Summary: Only renders thumbnail images for a given variant
 *          Triggers each time a product variant is changed or loaded.
 *          Requires the thumbnail images to have the alt tag set to the variant name to work or the variant id.
 *          Setting the thumbnail image to the alt text "all" will be visible irrespective of the variant selected.
 *
 * @param  {Object} product
 * @param  {Object} variant
 * @return {void}   Renders variant related thumbnail images
 **/

export const updateVariantImages = ({ product, variant }) => {
  // Variants that have no alt tag defined will automatically populate with the product title.
  const productTitle = product.title;
  const allThumbnailImages = document.querySelectorAll(
    '[data-pxl-variant-alt-text]'
  );

  [...allThumbnailImages].forEach((thumbnailImage) => {
    let thumbnailImageAltText = thumbnailImage.getAttribute(
      'data-pxl-variant-alt-text'
    );
    if (thumbnailImageAltText !== productTitle) {
      filterThumbnailImages(allThumbnailImages, variant);
    } else {
      if (__DEV__) {
        console.info(`Thumbnail image has no alt tag supplied`);
      }
      return false;
    }
  });
};

const filterThumbnailImages = (allThumbnailImages, variant) => {
  hideAllThumbnailImages(allThumbnailImages);

  [...allThumbnailImages].forEach((thumbnailImage) => {
    let variantIdStringFormatted = String(variant.id);
    const variantOption1 = String(variant.option1);
    let thumbnailImageAltText = thumbnailImage.getAttribute(
      'data-pxl-variant-alt-text'
    );
    let alwaysShowImageTag = 'all';

    if (
      thumbnailImageAltText === variantOption1 ||
      thumbnailImageAltText === variantIdStringFormatted ||
      thumbnailImageAltText === alwaysShowImageTag
    ) {
      renderThumbnailImage(thumbnailImage);
    }
  });
};

const hideAllThumbnailImages = (allThumbnailImages) => {
  [...allThumbnailImages].forEach((thumbnailImage) => {
    thumbnailImage.style.display = 'none';
  });
};

const renderThumbnailImage = (thumbnailImage) => {
  thumbnailImage.style.display = 'inline';
};
